import { render } from "./OrderOneStrykerAdmin.vue?vue&type=template&id=b39cd672&scoped=true"
import script from "./OrderOneStrykerAdmin.vue?vue&type=script&lang=js"
export * from "./OrderOneStrykerAdmin.vue?vue&type=script&lang=js"

import "./OrderOneStrykerAdmin.vue?vue&type=style&index=0&id=b39cd672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b39cd672"]])

export default __exports__